/* ZIRAK REVIEWS - only changes the Judge.me widget heading text. No elements are moved.
   To change the heading, edit the TITLE line below. */
(function () {
  var TITLE = 'What our customers are saying';
  function run() {
    document.querySelectorAll('.jdgm-rev-widg__title').forEach(function (el) {
      if (el.textContent.trim() !== TITLE) el.textContent = TITLE;
    });
  }
  function start() {
    run();
    if (!('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
